import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  // 메인 사이트 라우트
  {
    path: '/',
    name: 'MainHome',
    component: () => import('@/views/main/HomePage.vue'),
    meta: { title: '태백시 꿈탄탄 바우처카드' }
  },
  {
    path: '/intro',
    name: 'CardIntro',
    component: () => import('@/views/main/CardIntro.vue'),
    meta: { title: '카드 소개' }
  },
  {
    path: '/shops',
    name: 'ShopList',
    component: () => import('@/views/main/ShopList.vue'),
    meta: { title: '가맹점 안내' }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('@/views/main/Notice.vue'),
    meta: { title: '공지사항' }
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('@/views/main/Support.vue'),
    meta: { title: '고객센터' }
  },
  {
    path: '/balance',
    name: 'Balance',
    component: () => import('@/views/main/Balance.vue'),
    meta: { title: '잔액 조회' }
  },
  
  // 온라인 청소년 회원 신청 라우트
  {
    path: '/online-apply',
    component: () => import('@/layouts/ApplyLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/online-apply/check'
      },
      {
        path: 'check',
        name: 'YouthMemberCheck',
        component: () => import('@/views/youth/YouthMemberCheck.vue'),
        meta: { title: '신규 회원 확인', applicationType: 'youth' }
      },
      {
        path: 'verification',
        name: 'YouthVerification',
        component: () => import('@/views/youth/YouthVerification.vue'),
        meta: { title: '휴대폰 인증', applicationType: 'youth' }
      },
      {
        path: 'form',
        name: 'YouthApplyForm',
        component: () => import('@/views/youth/YouthApplyForm.vue'),
        meta: { title: '신청자 정보 입력 및 서류 업로드', applicationType: 'youth' }
      },
      {
        path: 'complete',
        name: 'YouthComplete',
        component: () => import('@/views/youth/YouthComplete.vue'),
        meta: { title: '신청 완료', applicationType: 'youth' }
      }
    ]
  },

  // 온라인 가맹점 신청 라우트
  {
    path: '/merchant-apply',
    component: () => import('@/layouts/ApplyLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/merchant-apply/check'
      },
      {
        path: 'check',
        name: 'MerchantCheck',
        component: () => import('@/views/merchant/MerchantCheck.vue'),
        meta: { title: '개인정보 수집 동의', applicationType: 'merchant' }
      },
      {
        path: 'form',
        name: 'MerchantApplyForm',
        component: () => import('@/views/merchant/MerchantApplyForm.vue'),
        meta: { title: '가맹점 신청', applicationType: 'merchant' }
      },
      {
        path: 'complete',
        name: 'MerchantComplete',
        component: () => import('@/views/merchant/MerchantComplete.vue'),
        meta: { title: '신청 완료', applicationType: 'merchant' }
      }
    ]
  },
  
  // 개인정보처리방침
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/main/Privacy.vue'),
    meta: { title: '개인정보처리방침' }
  },
  
  // 404 페이지
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: '페이지를 찾을 수 없습니다' }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  }
});

// 페이지 타이틀 설정
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} | 태백시 꿈탄탄 바우처카드` : '태백시 꿈탄탄 바우처카드';
  next();
});

export default router; 